export const DEEP_LINK_DESTINATIONS: Record<string, string> = {
  income: '/customer-hub/profile/income',
};

export const resolveDeepLinkDestination = (key: string | null | undefined): string | null => {
  if (!key) {
    return null;
  }

  return DEEP_LINK_DESTINATIONS[key.toLowerCase().trim()] ?? null;
};
